import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-edit-config-history',
  templateUrl: './edit-config-history.component.html',
  styleUrls: ['./edit-config-history.component.scss']
})
export class EditConfigHistoryComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
